import RootState from 'constants/RootState';
import { get } from 'lodash';
import { createSelector } from 'reselect';
import { StateProps } from 'components/ChromeExtension';

const getIsWaitingForInstall = (state: RootState): boolean => get(state, 'app.isWaitingForExtensionInstall');

const extensionSelector = createSelector([getIsWaitingForInstall],
  (isWaitingForExtensionInstall: boolean): StateProps => {
    return {
      isWaitingForExtensionInstall
    };
  });

export default extensionSelector;



// WEBPACK FOOTER //
// ./src/selectors/chromeExtension.ts